import { expandAppUserCredentialView, AppUserCredentialValue } from 'lib/actions/settings/vault'
import {
    AppUserCredentialRef,
    AppUserCredentialServiceSearchTermsResponse,
    AppUserCredentialView,
    AppUserCredentialViewWithVaultID,
    SearchAppUserHasAppUserCredentialsResponse,
} from 'pbts/c1/api/app/v1/app_user'
import { AppUserCredentialServiceClient } from 'pbts/c1/api/app/v1/app_user.client'
import { FacetValue } from 'pbts/c1/api/search/v1/facet'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'
import { createMutationApi } from './lib/createMutationApi'

const transformAppUserCredentialValueResponse = (resp): Array<AppUserCredentialValue> => {
    return resp.list.map((v: AppUserCredentialView): AppUserCredentialValue => {
        return expandAppUserCredentialView(v, resp.expanded)
    })
}

const transformAppUserCredentialValueWithVaultIDResponse = (resp): Array<AppUserCredentialValue> => {
    return resp.list.map((item: AppUserCredentialViewWithVaultID): AppUserCredentialValue => {
        const view = item.item // Get the inner AppUserCredentialView
        const value = expandAppUserCredentialView(view, item.expanded)
        value.vaultId = item.vaultId || '' // Add the vaultId from the outer structure
        return value
    })
}

export const searchAppUserCredentialsByVaultID = createPagedListApi(
    AppUserCredentialServiceClient,
    'searchAppUserCredentialsByVaultID',
    transformAppUserCredentialValueResponse,
    AppUserCredentialRef.typeName,
)

export const deleteCredentialApi = createMutationApi(
    AppUserCredentialServiceClient,
    'delete',
    undefined,
    AppUserCredentialRef.typeName,
)

const transformFacetResponse = (d: AppUserCredentialServiceSearchTermsResponse): Array<FacetValue> => {
    const item = d?.facets?.facets?.[0]?.item
    return item?.oneofKind === 'value' ? item.value?.values : []
}

export const AppUserCredentialSearchTermsApi = createUnaryApi(
    AppUserCredentialServiceClient,
    'getSearchTerms',
    transformFacetResponse,
)

export const listAppUserCredentialsWithVaultApi = createPagedListApi(
    AppUserCredentialServiceClient,
    'listAppUserCredentialsWithVault',
    transformAppUserCredentialValueWithVaultIDResponse,
    undefined,
)

export const searchAppUserHasAppUserCredentialsApi = createUnaryApi(
    AppUserCredentialServiceClient,
    'searchAppUserHasAppUserCredentials',
    (resp: SearchAppUserHasAppUserCredentialsResponse) => ({ hasCredentials: resp.hasAppUserCredentials }),
)
